import { useRef } from 'react';
import { generateIdempotencyKey } from './idempotency-key.js';

export { newIdempotencyKey } from './api-error.js';
export { generateIdempotencyKey } from './idempotency-key.js';

/**
 * One idempotency key per decision (P3-4), kept until that decision succeeds. A retry of the same approve or reject
 * on the same request resends the same key, so the server returns the first result instead of acting twice. A fresh
 * key per click, which `idempotentRequest()` gives, defeats that for a retry after a lost response.
 */
export function useStableIdempotency(): {
  request: (scope: string) => { extraHeaders: { 'Idempotency-Key': string } };
  done: (scope: string) => void;
} {
  const keys = useRef(new Map<string, string>());
  return {
    request(scope) {
      let key = keys.current.get(scope);
      if (!key) {
        key = generateIdempotencyKey();
        keys.current.set(scope, key);
      }
      return { extraHeaders: { 'Idempotency-Key': key } };
    },
    done(scope) {
      keys.current.delete(scope);
    },
  };
}

export function idempotentRequest(): { extraHeaders: { 'Idempotency-Key': string } } {
  return {
    extraHeaders: {
      'Idempotency-Key': generateIdempotencyKey(),
    },
  };
}
